import { ROLES } from "../store/user-slice";

export const mapRoleDisplay = (role?: string): string => {
  switch (role) {
    case ROLES.TECHNICIAN:
      return "Techniker";
    case ROLES.ADMIN:
      return "Admin";
    case ROLES.CUSTOMER_ADMIN:
      return "Kunde Admin";
    case ROLES.PROPERTY_MANAGER:
      return "Objektbetreuer";
    default:
      return role ?? "";
  }
};

export const mapRoleDisplayToRole = (roleDisplay: string): string => {
  switch (roleDisplay.toLowerCase()) {
    case "techniker":
      return ROLES.TECHNICIAN;
    case "admin":
      return ROLES.ADMIN;
    case "kunde admin":
      return ROLES.CUSTOMER_ADMIN;
    case "objektbetreuer":
      return ROLES.PROPERTY_MANAGER;
    default:
      return "";
  }
};
